<template>
  <div class="page page--editor">
    <nav-bar />
    <div class="page-wrapper">
      <div class="editor editor--profile">
        <div class="profile">
          <p v-if="isWizard" class="wizard-step">Шаг 1</p>
          <h1 class="editor--title">Контактные данные</h1>
          <p class="editor--subtitle">
            Заполните контактные данные, которые будут отображаться на вашей
            личной странице. Часть данных мы взяли из Amway ID, но вы можете их
            изменить.
          </p>
          <div class="profile__block" v-if="!$store.state.userTypes.vip">
            <h2 class="profile__subtitle">1. Выберите форму вашего бизнеса</h2>
            <div class="profile__inputs_group">
              <CRadio
                :options="businessTypes"
                name="business_type"
                :default-value="content.business_type"
                v-model="content.business_type"
              />
            </div>
          </div>
          <div class="profile__block">
            <h2 class="profile__subtitle" v-if="!$store.state.userTypes.vip">
              2. Заполните контактные данные
            </h2>
            <h2 class="profile__subtitle" v-if="$store.state.userTypes.vip">
              1. Заполните контактные данные
            </h2>
            <div class="profile__inputs_group">
              <CInput
                placeholder="Введите ваше имя"
                label="Имя*"
                v-model="content.firstname"
                :init-val="content.firstname"
                v-show="content.business_type === 'ie'"
                type="text"
                @valid="validation.firstname = true"
                @invalid="validation.firstname = false"
                :required="true"
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
              <CInput
                placeholder="Введите вашу фамилию"
                label="Фамилия*"
                v-model="content.lastname"
                :init-val="content.lastname"
                v-show="content.business_type === 'ie'"
                type="text"
                :required="true"
                @valid="validation.lastname = true"
                @invalid="validation.lastname = false"
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
              <CInput
                placeholder="Введите название компании"
                label="Название компании*"
                v-model="content.company_name"
                :init-val="content.company_name"
                v-show="content.business_type === 'ltd'"
                type="text"
                :required="true"
                @valid="validation.company_name = true"
                @invalid="validation.company_name = false"
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
              <CInput
                placeholder="Укажите ваш город"
                label="Город*"
                v-model="content.city"
                :init-val="content.city"
                type="text"
                :required="true"
                @valid="validation.city = true"
                @invalid="validation.city = false"
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
              <CPhone
                label="Телефон*"
                :default-value="content.phone"
                v-model="content.phone"
                @valid="validation.phone = true"
                @invalid="validation.phone = false"
              />
              <CInput
                label="Email*"
                placeholder="name@mail.ru"
                :init-val="content.email"
                v-model="content.email"
                type="email"
                @valid="validation.email = true"
                @invalid="validation.email = false"
                :required="true"
                tooltip="Email должен быть не короче 6 знаков и состоять из символов латинского алфавита."
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
              <div v-if="content.items" class="profile__additional_container">
                <CInput
                  v-for="(messenger, index) in content.items"
                  v-if="messenger.fieldType !== 'phone'"
                  :key="`nophone-${index}`"
                  :type="messenger.fieldType"
                  :label="messenger.label"
                  :placeholder="messenger.field"
                  :init-val="messenger.value"
                  :removable="true"
                  v-model="messenger.value"
                  @removeit="removeCommunication(index)"
                  @valid="validation.messengers[index] = true"
                  @invalid="validation.messengers[index] = false"
                />
                <CPhone
                  :key="`phone-${index}`"
                  :label="messenger.label"
                  :default-value="messenger.value"
                  v-model="messenger.value"
                  :removable="true"
                  @removeit="removeCommunication(index)"
                  @valid="validation.messengers[index] = true"
                  @invalid="validation.messengers[index] = false"
                  v-else
                />
              </div>
              <CSelectAdv
                :options="additionalCommunication"
                label="Дополнительные каналы связи"
                blank="Добавить канал связи"
                :choose-only="true"
                @select="addCommunication"
                @click="showTooltip"
                tooltip="Вы можете добавить до 20 дополнительных каналов связи."
                :tooltip_action="show_tooltip"
                tooltip_position="right"
              />
            </div>
            <span class="profile__disclaimer"
              >* — отмечены обязательные для заполнения поля</span
            >
          </div>
          <div class="profile__block" v-if="content.business_type === 'ie'">
            <h2 class="profile__subtitle" v-if="!$store.state.userTypes.vip">
              3. У вас есть назначенное лицо?
            </h2>
            <h2 class="profile__subtitle" v-if="$store.state.userTypes.vip">
              2. У вас есть назначенное лицо?
            </h2>
            <div class="profile__inputs_group">
              <CCheckbox
                label="Добавить назначенное лицо"
                v-model="addPartner"
              />
              <CInput
                v-show="addPartner"
                label="Имя"
                placeholder="Введите имя назначенного лица"
                :init-val="content.partner_firstname"
                v-model="content.partner_firstname"
                @valid="validation.partner_firstname = true"
                @invalid="validation.partner_firstname = false"
                type="type"
                tooltip="Добавьте имя своего назначенного лица."
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
              <CInput
                v-show="addPartner"
                label="Фамилия"
                placeholder="Введите фамилию назначенного лица"
                :init-val="content.partner_lastname"
                v-model="content.partner_lastname"
                @valid="validation.partner_lastname = true"
                @invalid="validation.partner_lastname = false"
                type="type"
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
            </div>
          </div>
          <div class="profile__block">
            <h2
              v-if="
                content.business_type === 'ltd' || $store.state.userTypes.vip
              "
              class="profile__subtitle"
            >
              3. Загрузите фото
            </h2>
            <h2 v-else class="profile__subtitle">4. Загрузите фото</h2>
            <div class="profile__inputs_group">
              <CAvatarInput
                :current-avatar="content.avatar"
                v-model="content.avatar"
                @valid="validation.avatar = true"
                @invalid="validation.avatar = false"
                tooltip="Загрузите свое фото."
                :tooltip_action="show_tooltip"
                tooltip_position="right"
              />
            </div>
          </div>
          <div class="profile__block">
            <h2 class="profile__subtitle">Дополнительная информация</h2>
            <div class="profile__inputs_group profile__inputs_moreinfo">
              <CInput
                type="textarea"
                :init-val="content.about"
                v-model="content.about"
                label="О себе"
                :big="true"
                placeholder="Напишите о себе"
                tooltip_position="right"
                alarm_msg="Заполните поле корректно."
              />
            </div>
          </div>
          <div class="profile__buttons profile__buttons--nopad" v-if="isWizard">
            <button
              v-if="isWizard"
              class="pBtn pBtn--blue"
              :class="{ 'pBtn--disabled': !allIsValid }"
              @click="wizardNextStep"
            >
              Далее
            </button>
          </div>
        </div>
        <div class="profile__buttons" v-if="!isWizard">
          <button class="pBtn pBtn--noborder" @click="$router.go(-1)">
            <svg-icon type="back" /> Назад
          </button>
          <button class="pBtn pBtn--blue" @click="save">Сохранить</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CRadio from "../../components/forms/CRadio";
import { mapGetters } from "vuex";
import CInput from "../../components/forms/CInput";
import CPhone from "../../components/forms/CPhone";
import CSelect from "../../components/forms/CSelect";
import CSelectAdv from "../../components/forms/CSelectAdv";
import CAvatarInput from "../../components/forms/CAvatarInput";
import CCheckbox from "../../components/forms/CCheckbox";
import CTooltip from "../../components/forms/CTooltip";

function all(iterable) {
  for (let index = 0; index < iterable.length; index++) {
    if (!iterable[index]) return false;
  }
  return true;
}

export default {
  name: "Profile",
  props: ["isWizard"],
  components: {
    CCheckbox,
    CAvatarInput,
    CSelect,
    CPhone,
    CInput,
    CRadio,
    CSelectAdv,
    CTooltip
  },
  data() {
    return {
      show_tooltip: true,
      addPartner: false,
      additionalCommunication: [
        {
          label: "Телефон",
          icon: "phone",
          type: "phone",
          fieldType: "phone",
          prefix: "tel:",
          field: "Укажите номер телефона",
          value: ""
        },
        {
          label: "Электронная почта",
          icon: "message",
          fieldType: "email",
          type: "mail",
          prefix: "mailto:",
          field: "Введите ваш контактный e-mail",
          value: ""
        },
        {
          label: "Skype",
          icon: "skype",
          type: "skype",
          fieldType: "latin",
          prefix: "skype:",
          field: "Введите ваш логин",
          value: ""
        },
        {
          label: "Telegram",
          icon: "telegram",
          fieldType: "latin",
          type: "telegram",
          prefix: "tg://resolve?domain=",
          field: "Укажите ник телеграма",
          value: ""
        },
        {
          label: "WhatsApp",
          icon: "whatsapp",
          fieldType: "phone",
          type: "whatsapp",
          prefix: "https://wa.me/",
          field: "Укажите номер телефона",
          value: ""
        },
        {
          label: "Viber",
          icon: "viber",
          fieldType: "phone",
          type: "viber",
          prefix: "viber://add?number=",
          field: "Укажите номер телефона",
          value: ""
        }
      ],
      content: {
        firstname: "",
        lastname: "",
        company_name: "",
        partner_firstname: "",
        partner_lastname: "",
        about: "",
        city: "",
        phone: "",
        email: "",
        messenger_phone: "",
        skype: "",
        business_type: "ie",
        items: [],
        messengers: [
          {
            label: "WhatsApp",
            value: "WhatsApp",
            enabled: false
          },
          {
            label: "Viber",
            value: "Viber",
            enabled: false
          }
        ],
        avatar: ""
      },
      validation: {
        firstname: null,
        lastname: null,
        company_name: null,
        partner_firstname: null,
        partner_lastname: null,
        city: null,
        phone: null,
        email: null,
        avatar: null,
        messengers: []
      }
    };
  },
  computed: {
    ...mapGetters(["getComponentByName"]),
    allIsValid() {
      return this.isValid();
    },
    businessTypes() {
      console.log(this.$store.state.isKZ);
      let returnTypes = [
        {
          label: "ИП",
          value: "ie"
        },
        {
          label: "Компания",
          value: "ltd"
        }
      ];
      if (!this.$store.state.isKZ) {
        returnTypes[0].label = "ИП/Самозанятый";
      }
      return returnTypes;
    }
  },
  methods: {
    showTooltip() {
      this.show_tooltip = false;
    },
    fillFromState() {
      if (this.getComponentByName("Profile")) {
        const { content } = this.getComponentByName("Profile");
        Object.keys(content).forEach(key => {
          if (key === "skype") {
            if (this.content["skype"] !== "") {
              this.content.items.push({
                value: this.content[key],
                name: "Skype",
                type: "skype",
                label: "Skype",
                field: "Введите ваш логин"
              });
              this.content[key] = "";
            }
          } else if (key === "partner_firstname") {
            if (content[key]) {
              this.addPartner = true;
            }
            this.content[key] = content[key];
          } else if (key === "displayrole") {
            this.content.business_type = content[key] ? "ie" : "ltd";
          } else if (key === "messenger_phone") {
            if (content["messenger_phone"] !== "") {
              if (content["messengers"][0].enabled) {
                this.content.items.push({
                  value: content["messenger_phone"],
                  name: "WhatsApp",
                  type: "whatsapp",
                  label: "WhatsApp",
                  field: "Укажите номер телефона"
                });
              } else {
                if (content["messengers"][1].enabled) {
                  this.content.items.push({
                    value: content["messenger_phone"],
                    name: "Viber",
                    type: "viber",
                    label: "Viber",
                    field: "Укажите номер телефона"
                  });
                }
              }
            }
            this.content[key] = "";
          } else if (key === "items") {
            content[key].forEach(i => {
              this.validation.messengers.push(null);
              if (!i.fieldType) {
                switch (i.type) {
                  case "phone":
                  case "whatsapp":
                  case "viber":
                    i.fieldType = "phone";
                    break;
                  case "mail":
                    i.fieldType = "email";
                    break;
                  default:
                    i.fieldType = "text";
                    break;
                }
              }
            });
            this.content[key] = content[key];
          } else {
            this.content[key] = content[key];
          }
        });
        this.validation.email = !!this.content.email;
      }
    },
    addCommunication(option) {
      this.content.items.push(option);
    },
    removeCommunication(index) {
      this.content.items.splice(index, 1);
      this.validation.messengers.splice(index, 1);
    },
    isValid() {
      let invalid = false;
      if (this.content.business_type === "ie") {
        this.validation.company_name = null;
        this.validation.firstname = !!this.content.firstname;
        this.validation.lastname = !!this.content.lastname;
        this.validation.partner_firstname = !!this.content.partner_firstname;
        this.validation.partner_lastname = !!this.content.partner_lastname;
      } else {
        this.validation.company_name = !!this.content.company_name;
        this.validation.firstname = null;
        this.validation.lastname = null;
        this.validation.partner_firstname = null;
        this.validation.partner_lastname = null;
      }
      if (!this.addPartner) {
        this.validation.partner_firstname = null;
        this.validation.partner_lastname = null;
      } else {
        this.validation.partner_firstname = !!this.content.partner_firstname;
        this.validation.partner_lastname = !!this.content.partner_lastname;
      }
      for (let k in this.validation) {
        if (this.validation[k] === false) {
          invalid = true;
        }
        if (k === "messengers") {
          invalid = !all(this.validation[k]);
        }
        if (invalid) {
          break;
        }
      }
      return !invalid;
    },
    save() {
      let invalid = !this.isValid();
      if (!this.content.avatar) {
        this.$eventBus.$emit("showError", {
          error: "Вы забыли загрузить фотографию"
        });
        return false;
      }
      if (invalid) {
        window.scroll(0, 0);
        this.$eventBus.$emit("showError", {
          error: "Вы неправильно заполнили данные"
        });
        return false;
      }
      if (!this.addPartner) {
        this.content.partner_firstname = "";
        this.content.partner_lastname = "";
        this.validation.partner_lastname = null;
        this.validation.partner_firstname = null;
      }
      this.content.items = this.content.items.filter(i => i.value);
      const { content } = this;
      const saveToVuexAndServer = () => {
        return this.$store.dispatch("syncComponent", {
          id: this.getComponentByName("Profile").id,
          content: Object.assign({}, content),
          enabled: true
        });
      };
      saveToVuexAndServer();
      return true;
    },
    wizardNextStep() {
      if (this.save()) {
        this.$store.dispatch("wizardStepChange", 2);
        this.$router.push("/wizard/2");
        if (this.content.partner_firstname && this.content.partner_lastname) {
          this.GAEvent(
            "step_1-success_registration",
            "account_type",
            this.content.business_type === "ie" ? "ИП" : "ООО",
            "city",
            this.content.city,
            "partner",
            `${this.content.partner_firstname} ${this.content.partner_lastname}`
          );
        } else {
          this.GAEvent(
            "step_1-success_registration",
            "account_type",
            this.content.business_type === "ie" ? "ИП" : "ООО",
            "city",
            this.content.city
          );
        }
      }
    }
  },
  created() {
    this.fillFromState();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.page {
  @media #{$tablet} {
    padding-bottom: 0;
  }
}
.page-wrapper {
  max-width: 100%;
  display: flex;
  justify-content: center;
  padding-bottom: 60px;
  @media #{$tablet} {
    margin: 0;
    padding: 0;
  }
}

.profile {
  max-width: 600px;
  margin: 0 auto;
  @media #{$tablet} {
    margin: 0;
  }
  &__subtitle {
    font-size: 24px;
    color: #303333;
    line-height: 140%;
    text-indent: -23px;
    margin-bottom: 30px;
    @media #{$tablet} {
      text-indent: 0;
    }
    @media #{$mobile} {
      font-size: 28px;
    }
  }

  &__block {
    margin-bottom: 45px;
  }

  &__inputs_group {
    max-width: 290px;
    & .checkbox {
      margin-bottom: 10px;
    }
    @media #{$mobile} {
      max-width: 100%;
    }
  }
  &__inputs_moreinfo {
    max-width: 490px;
    :global textarea {
      height: 148px;
    }
  }
  &__buttons {
    background: #ffffff;
    padding: 30px 70px;
    display: flex;
    justify-content: space-between;
    &--nopad {
      padding-left: 0;
      padding-right: 0;
    }
    @media #{$mobile} {
      flex-direction: column-reverse;
      padding: 0 15px;
    }
  }
  &__disclaimer {
    font-weight: bold;
    font-size: 17px;
    margin-top: 10px;
  }
}
.profile__inputs_moreinfo :global textarea {
  height: 148px !important;
}
</style>
